import { render, staticRenderFns } from "./UnitCarousel.vue?vue&type=template&id=3e6c634d&scoped=true&"
import script from "./UnitCarousel.vue?vue&type=script&lang=js&"
export * from "./UnitCarousel.vue?vue&type=script&lang=js&"
import style0 from "./UnitCarousel.vue?vue&type=style&index=0&id=3e6c634d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c634d",
  null
  
)

export default component.exports